module.exports = __webpack_public_path__ + "7c7cd6cc3c69aa01295e07f4c8eb69d7.svg";